// src/components/hub/work/DeleteConfirmModal.js
import React from "react";
import {
  popupBg,
  popupBorder,
  popupText,
  popupSubtext,
  popupBtn,
  popupDestructive,
} from "../constants";

const DeleteConfirmModal = ({
  open,
  ids = [],
  archiveFallbackIds = null,
  onConfirmDelete,
  onConfirmArchive,
  onClose,
}) => {
  if (!open || !ids.length) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/30" onClick={onClose} />
      <div
        className={`relative ${popupBg} ${popupBorder} ${popupText} rounded-xl shadow-xl p-6 w-96`}
      >
        {archiveFallbackIds ? (
          <>
            <p className={`text-sm font-semibold ${popupText} mb-2`}>
              Some items could not be deleted
            </p>
            <p className={`text-xs ${popupSubtext} mb-4`}>
              Effort is logged or commitments exist on these items. Archive removes
              them from the active view without losing records.
            </p>
            <div className="flex gap-2 justify-end">
              <button
                type="button"
                onClick={onClose}
                className={`text-xs px-3 py-1.5 rounded-lg ${popupBtn} border border-gray-200 dark:border-gray-700`}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={() => onConfirmArchive(archiveFallbackIds)}
                className="text-xs px-3 py-1.5 rounded-lg bg-[#32B1FF] text-white hover:bg-[#1a9ce6]"
              >
                Archive {archiveFallbackIds.length} item(s) instead
              </button>
            </div>
          </>
        ) : (
          <>
            <p className={`text-sm font-semibold ${popupText} mb-2`}>
              Delete {ids.length} item(s)?
            </p>
            <p className={`text-xs ${popupSubtext} mb-4`}>
              This is a soft delete. You can restore from the undo toast.
            </p>
            <div className="flex gap-2 justify-end">
              <button
                type="button"
                onClick={onClose}
                className={`text-xs px-3 py-1.5 rounded-lg ${popupBtn} border border-gray-200 dark:border-gray-700`}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={() => onConfirmDelete(ids)}
                className={`text-xs px-3 py-1.5 rounded-lg ${popupDestructive}`}
              >
                Delete
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
